import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { t } from "i18next";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { PieChart } from "@mui/x-charts";
import { ROLE } from "../../../../../utils/constants/profiles";
import { useSelector } from "react-redux";

const CardPieChart = ({ dataCategory, downloadExcel }) => {
  const role = useSelector((state) => state.app.role);
  const controlloDati = dataCategory.every((el) => el.value === undefined);

  return (
    <div className="flex-col w-full h-full shadow-md rounded-lg">
      <div className="flex w-full justify-between p-3">
        <p className="text-2xl font-bold m-0 ">Riepilogo per Categorie</p>
        {ROLE.USER !== role && (
          <Tooltip title={t("Download")}>
            <IconButton
              className="hidden" //disabled download
              onClick={() => downloadExcel("category")}
            >
              <DownloadRoundedIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
      <div className=" w-full flex justify-center">
        {controlloDati ? (
          <div
            style={{
              height: "350px",
            }}
            className="flex w-full justify-center items-center"
          >
            <p className="text-gray">Nessun Documento</p>
          </div>
        ) : (
          <div
            style={{
              height: "350px",
            }}
            className="w-full flex justify-center items-center pe-8"
          >
            <PieChart
              dataset={dataCategory}
              series={[
                {
                  data: dataCategory,
                  innerRadius: 30,
                  cx: 150,
                },
              ]}
              height={250}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CardPieChart;
